import { Theme } from '@mui/material/styles';
import { TypographyOptions } from '@mui/material/styles/createTypography';

import { MAIN_MARGIN_TOP_PX } from 'constant';

const Typography = (theme: Theme, borderRadius: number, fontFamily: string): TypographyOptions => ({
    fontFamily,
    h6: {
        fontWeight: 500,
        color: theme.palette.text.dark,
        fontSize: '0.75rem'
    },
    h5: {
        fontSize: '0.875rem',
        color: theme.palette.text.dark,
        fontWeight: 500
    },
    h4: {
        fontSize: '1rem',
        color: theme.palette.text.dark,
        fontWeight: 600
    },
    h3: {
        fontSize: '1.125rem',
        color: theme.palette.text.dark,
        fontWeight: 600
    },
    h2: {
        fontSize: '1.5rem',
        color: theme.palette.text.dark,
        fontWeight: 700
    },
    h1: {
        fontSize: '1.75rem',
        color: theme.palette.text.dark,
        fontWeight: 800
    },
    subtitle1: {
        fontSize: '0.875rem',
        fontWeight: 500,
        color: theme.palette.text.dark
    },
    subtitle2: {
        fontSize: '0.75rem',
        fontWeight: 400,
        color: theme.palette.mode === 'light' ? '#999999' : theme.palette.text.secondary
    },
    caption: {
        fontSize: '0.75rem',
        color: theme.palette.mode === 'light' ? '#999999' : theme.palette.text.secondary,
        fontWeight: 400
    },
    body1: {
        fontSize: '0.875rem',
        fontWeight: 400,
        lineHeight: '1.334em',
        color: theme.palette.text.primary
    },
    body2: {
        fontSize: '0.8125rem',
        letterSpacing: '0em',
        fontWeight: 400,
        lineHeight: '1.5em',
        color: theme.palette.text.secondary
    },
    button: {
        textTransform: 'capitalize'
    },
    customInput: {
        marginTop: 1,
        marginBottom: 1,
        '& > label': {
            top: 23,
            left: 0,
            color: theme.palette.grey[500],
            '&[data-shrink="false"]': {
                top: 5
            }
        },
        '& > div > input': {
            padding: '30.5px 14px 11.5px !important'
        },
        '& legend': {
            display: 'none'
        },
        '& fieldset': {
            top: 0
        }
    },
    mainContent: {
        // App.jsx T.bg — tighter top padding so content sits closer to the navbar (was 20px all sides)
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.dark[800] : '#F8F8F8',
        width: '100%',
        minHeight: `calc(100vh - ${MAIN_MARGIN_TOP_PX}px)`,
        flexGrow: 1,
        // Full-width main strip — horizontal padding left to route pages (e.g. Dashboard) via content
        padding: '8px 0 20px 0',
        marginTop: `${MAIN_MARGIN_TOP_PX}px`,
        marginRight: 0,
        borderRadius: `${borderRadius}px`
    },
    // App.jsx sidebar section labels — fontSize 11, fontWeight 600, T.textLight
    menuCaption: {
        fontSize: '0.6875rem',
        fontWeight: 600,
        letterSpacing: 0.3,
        color: theme.palette.mode === 'light' ? '#999999' : theme.palette.text.secondary,
        padding: '6px',
        textTransform: 'capitalize',
        marginTop: '10px'
    },
    subMenuCaption: {
        fontSize: '0.6875rem',
        fontWeight: 500,
        color: theme.palette.text.secondary,
        textTransform: 'capitalize'
    },
    commonAvatar: {
        cursor: 'pointer',
        borderRadius: '8px'
    },
    smallAvatar: {
        width: '22px',
        height: '22px',
        fontSize: '1rem'
    },
    mediumAvatar: {
        width: '34px',
        height: '34px',
        fontSize: '1.2rem'
    },
    largeAvatar: {
        width: '44px',
        height: '44px',
        fontSize: '1.5rem'
    }
});

export default Typography;
